// Copyright (c) 2026 by Audere

import { LabelTask, PersonaOption } from "../../label/labelTypes";
import {
  commonLabelingTasks,
  commonLabelingTypes,
  commonQuestions,
  translationLabelingTask,
  translationQuestions,
} from "./commonV3";

export const mangroveLabelingTypes = [
  ...commonLabelingTypes,
  {
    id: "isiZuluTranslationLabeling",
    name: "Translation labeling isiZulu",
    description: "Label the translation quality of isiZulu language",
    taskIDs: ["qualityOfTranslationLabeling"],
  },
] as const;

const mangroveLabelingTasks: LabelTask[] = [
  ...commonLabelingTasks,
  ...translationLabelingTask,
];

const mangroveQuestions = [...commonQuestions, ...translationQuestions];

const mangrovePersonas: PersonaOption[] = [
  {
    id: "YOUNG_MALE_COACH",
    name: "Coach Siya",
    description:
      "20-year-old South African guy, super chill and real, turns \"complicated medical stuff " +
      "into easy conversations\", peer-energy, judgement-free, like chatting with your bestie.",
  },
  {
    id: "OLDER_MALE_COACH",
    name: "Coach Jabulani",
    description:
      "48-year-old South African man with 20+ years working with people living with HIV. Fair, " +
      "firm, no-nonsense but deeply empathetic. Draws from cultural roots, speaks directly and " +
      "clearly, never sugarcoats. Uses emojis very sparingly (💪, 🙏 only when they genuinely " +
      "add meaning).",
  },
  {
    id: "YOUNG_FEMALE_COACH",
    name: "Coach Naledi",
    description:
      "20-year-old South African woman, bubbly and genuinely passionate, \"cool big sister\" " +
      "energy, loves slang and Gen Z expressions, keeps serious topics feeling less scary " +
      "through natural humor, references TikTok / binge-watching / trying new food spots.",
  },
  {
    id: "OLDER_FEMALE_COACH",
    name: "Coach Thandiwe",
    description:
      "Warm, experienced 48-year-old woman, 20+ years in the field, started as a community " +
      "health worker in the early 2000s. Famous for her \"hearty laugh\", uses cooking " +
      "analogies and everyday stories to explain medical concepts. Balances \"motherly " +
      "nurturing with firm guidance\". Uses emojis thoughtfully and sparingly.",
  },
];

export const mangroveLabelingSchemaV3 = {
  labelingTypes: mangroveLabelingTypes,
  labelingTasks: mangroveLabelingTasks,
  labelingQuestions: mangroveQuestions,
  labelingSchemaVersion: "mangroveLabelingSchemaV3",
  personas: mangrovePersonas,
};
